
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M1.394 16.697L9.88 1.593l8.484 15.104H1.394zm18.298.264L10.328.291a.509.509 0 00-.45-.251.507.507 0 00-.448.25L.066 16.961a.517.517 0 00.448.766h18.729a.516.516 0 00.45-.766z"}}),_c('path',{attrs:{"d":"M9.206 5.66v5.989c0 .227.182.407.454.407.226 0 .454-.18.454-.407V5.66c0-.227-.182-.408-.454-.408-.226 0-.454.18-.454.408m-.362 8.71a.816.816 0 101.632.002.816.816 0 00-1.632-.002"}})])])
          )
        }
      }
    